import { render, staticRenderFns } from "./TabAdress.vue?vue&type=template&id=169b1869&"
import script from "./TabAdress.vue?vue&type=script&lang=js&"
export * from "./TabAdress.vue?vue&type=script&lang=js&"
import style0 from "./TabAdress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports